import { render, staticRenderFns } from "./HealthInsurance.vue?vue&type=template&id=70edd806"
import script from "./HealthInsurance.vue?vue&type=script&lang=ts"
export * from "./HealthInsurance.vue?vue&type=script&lang=ts"
import style0 from "./HealthInsurance.vue?vue&type=style&index=0&id=70edd806&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports